import api from './api';

const productService = {
  getProducts: async (params = {}) => {
    try {
      const response = await api.get('/products', { params });
      return response.data;
    } catch (error) {
      console.error('获取商品列表失败:', error);
      throw error;
    }
  },

  getProduct: async (id, tenantId) => {
    try {
      const response = await api.get(`/products/${id}`, { params: { tenantId } });
      return response.data;
    } catch (error) {
      console.error('获取商品详情失败:', error);
      throw error;
    }
  },

  createProduct: async (data) => {
    try {
      const response = await api.post('/products', data);
      return response.data;
    } catch (error) {
      console.error('创建商品失败:', error);
      throw error;
    }
  },

  updateProduct: async (id, data) => {
    try {
      const response = await api.put(`/products/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('更新商品失败:', error);
      throw error;
    }
  },

  deleteProduct: async (id, tenantId) => {
    try {
      const response = await api.delete(`/products/${id}`, { params: { tenantId } });
      return response.data;
    } catch (error) {
      console.error('删除商品失败:', error);
      throw error;
    }
  },

  getActiveProducts: async (tenantId) => {
    try {
      const response = await api.get('/products/active', { params: { tenantId } });
      return response.data;
    } catch (error) {
      console.error('获取活跃商品失败:', error);
      throw error;
    }
  },

  getCategories: async (tenantId) => {
    try {
      const response = await api.get('/products/categories', { params: { tenantId } });
      return response.data;
    } catch (error) {
      console.error('获取分类列表失败:', error);
      throw error;
    }
  },

  importProducts: async (tenantId, file) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      const response = await api.post(`/products/import?tenantId=${tenantId}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    } catch (error) {
      console.error('批量导入失败:', error);
      throw error;
    }
  },

  downloadTemplate: () => {
    window.open('/api/products/import-template', '_blank');
  },
};

export default productService;
